import { useEffect } from "react";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { appState } from "../../state";
import { notifyStateChange } from "../../stateBus";
import { loadConversationsData } from "../../chatApi";

// Route-effect component for "/chat" (the list, not an open thread).
// Renders nothing - ChatListScreen.tsx (mounted unconditionally in AppRoot)
// owns the actual rendering into #chatListView.
export function ChatListRouteScreen() {
  useVisibleContainer("chatListView");

  useEffect(() => {
    appState.chatThreadId = null;
    notifyStateChange();
    loadConversationsData();
  }, []);

  return null;
}
